import { render, staticRenderFns } from "./CustomImageViewer.vue?vue&type=template&id=518b8e50&scoped=true"
import script from "./CustomImageViewer.vue?vue&type=script&lang=js"
export * from "./CustomImageViewer.vue?vue&type=script&lang=js"
import style0 from "./CustomImageViewer.vue?vue&type=style&index=0&id=518b8e50&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518b8e50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/local-vir-env-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518b8e50')) {
      api.createRecord('518b8e50', component.options)
    } else {
      api.reload('518b8e50', component.options)
    }
    module.hot.accept("./CustomImageViewer.vue?vue&type=template&id=518b8e50&scoped=true", function () {
      api.rerender('518b8e50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/previewImg/CustomImageViewer.vue"
export default component.exports